import { useNavigate, useLocation } from 'react-router-dom';

type NavigateParam = string | {
  pathname: string;
  search?: string;
};

export const useEmbeddedNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentSearchParams = new URLSearchParams(location.search);
  const embed = currentSearchParams.get('embed');
  const etoken = currentSearchParams.get('etoken');
  const lang = currentSearchParams.get('lang');

  return (path: NavigateParam | number) => {
    if (typeof path === 'number') {
      navigate(path);
      return;
    }

    let pathname: string;
    let finalSearchParams = new URLSearchParams();

    if (typeof path === 'string') {
    const [cleanPathname, searchPart] = path.split('?');
    pathname = cleanPathname;
    finalSearchParams = new URLSearchParams(searchPart || '');
    }
    else {
      pathname = path.pathname;
      finalSearchParams = new URLSearchParams(path.search || '');
    }

    if (embed) finalSearchParams.set('embed', embed);
    if (etoken) finalSearchParams.set('etoken', etoken);
    if (lang) finalSearchParams.set('lang', lang);

    const search = finalSearchParams.toString();
    navigate(`${pathname}${search ? `?${search}` : ''}`);
  };
};